export const translations = {
  tr: {
    nav: {
      about: "Kimiz?",
      services: "Hizmetler",
      portfolio: "Çalışmalar",
      blog: "Blog",
      contact: "İletişim",
      advertising: "Reklamın Önemi",
      cta: "Teklif Al",
    },
    hero: {
      badge: "Premium Dijital Ajans",
      titlePre: "Dijital Dünyada ",
      titleHighlight: "İz Bırakan",
      titlePost: " Markalar Oluşturuyoruz",
      desc: "Premium dijital çözümler, marka kimliği, web tasarım, yazılım geliştirme ve büyüme stratejileri ile markanızı geleceğe taşıyoruz.",
      primary: "Teklif Al",
      secondary: "Projelerimizi İncele",
      awardTitle: "Awwwards",
      awardSub: "Günün Sitesi",
      statValue: "+%180",
      statSub: "Ort. Dönüşüm",
      stats: [
        { value: "150+", label: "Tamamlanan Proje" },
        { value: "90+", label: "Mutlu Müşteri" },
        { value: "%98", label: "Başarı Oranı" },
      ],
    },
    marquee: {
      label: "Uzmanlık alanlarımız",
      words: ["Google ADS", "Web Tasarım", "Sosyal Medya", "Meta ADS", "E-Ticaret", "Pazarlama", "Strateji", "TikTok ADS"],
    },
    quotes: {
      tag: "İlham",
      title: "Reklamın Önemi",
      subtitle: "Reklamcılığın gücünü en iyi özetleyen sözler.",
      items: [
        { author: "Henry Ford", text: "İş yapmayı bırakmak istemiyorsanız, reklam yapmayı bırakmayın." },
        { author: "Howard Gossage", text: "İnsanlar reklam okumaz; ilgilerini çeken şeyleri okurlar. Bazen bu bir reklam olur." },
        { author: "Mark Twain", text: "Doğru türde reklam, küçük bir şeyi bile büyük yapabilir." },
        { author: "Henry Ford", text: "Para tasarrufu yapmak için reklam vermeyi bırakan bir adam, zaman kazanmak için saati durduran bir adama benzer." },
      ],
    },
    services: {
      tag: "Hizmetlerimiz",
      title: "Markanızı büyüten reklam çözümleri",
      subtitle:
        "Veri odaklı kampanyalar ve yaratıcı içeriklerle dijitalde fark yaratıyoruz.",
      cta: "Hemen Başlayın",
      items: [
        {
          slug: "google-ads",
          title: "Google ADS",
          sub: "Arama Ağında Zirve",
          desc: "Doğru anahtar kelimeler ve veri odaklı kampanyalarla, müşterileriniz tam aradıkları anda karşılarına çıkıyoruz.",
          features: ["Arama & Display Ağı", "Yeniden Pazarlama", "Dönüşüm Takibi"],
          metrics: [{ label: "Reklam Getirisi (ROAS)", value: "4.2x" }, { label: "Dönüşüm Oranı", value: "+%65" }],
        },
        {
          slug: "meta-ads",
          title: "Meta ADS",
          sub: "Sosyalde Görünürlük",
          desc: "Facebook ve Instagram'da hedef kitlenize özel, dönüşüm odaklı reklam funnel'ları kuruyoruz.",
          features: ["Facebook & Instagram", "Hedef Kitle Analizi", "Yaratıcı Reklamlar"],
          metrics: [{ label: "Toplam Erişim", value: "3.5M" }, { label: "Tıklama Başına Maliyet", value: "-%40" }],
        },
        {
          slug: "tiktok-ads",
          title: "TikTok ADS",
          sub: "Viral Büyüme",
          desc: "Trendleri yakalayan yaratıcı içeriklerle markanızı yeni nesil kitlelerle buluşturuyoruz.",
          features: ["Trend İçerikler", "Influencer İşbirlikleri", "Video Prodüksiyon"],
          metrics: [{ label: "Görüntülenme", value: "12M+" }, { label: "Etkileşim Oranı", value: "+%120" }],
        },
        {
          slug: "social-media",
          title: "Sosyal Medya Yönetimi",
          sub: "Marka Sesiniz",
          desc: "İçerik üretiminden topluluk yönetimine kadar sosyal medya hesaplarınızı uçtan uca yönetiyoruz.",
          features: ["İçerik Takvimi", "Topluluk Yönetimi", "Aylık Raporlama"],
          metrics: [{ label: "Takipçi Artışı", value: "+%85" }, { label: "Etkileşim", value: "+%140" }],
        },
      ],
    },
    about: {
      tag: "Kimiz?",
      title: "Yaratıcılığı teknolojiyle buluşturan ekip",
      subtitle:
        "LUKI; markaların dijital dünyada fark yaratması için strateji, tasarım ve teknolojiyi bir araya getiren bir dijital ajanstır.",
      paragraphs: [
        "Tilkimiz kadar zeki, çevik ve meraklıyız. Her projeye ölçülebilir hedefler ve cesur fikirlerle yaklaşıyoruz.",
        "Tasarımı bir his, teknolojiyi ise bir araç olarak görüyoruz; ikisini birleştirerek kalıcı dijital deneyimler üretiyoruz.",
      ],
      mission: {
        title: "Misyonumuz",
        desc: "Markaları dijitalde akılda kalıcı, ölçülebilir ve sürdürülebilir deneyimlerle büyütmek.",
      },
      vision: {
        title: "Vizyonumuz",
        desc: "Türkiye'den dünyaya uzanan, tasarım ve teknolojide referans gösterilen bir ajans olmak.",
      },
      stats: [
        { value: "98%", label: "Müşteri Sadakati" },
        { value: "3 saat", label: "Ort. Yanıt Süresi" },
      ],
      timelineTitle: "Yolculuğumuz",
      timeline: [
        { year: "2013", title: "Kuruluş", desc: "LUKI küçük bir tasarım stüdyosu olarak yola çıktı." },
        { year: "2017", title: "Büyüme", desc: "Ekibimizi büyüttük ve yazılım hizmetlerini ekledik." },
        { year: "2021", title: "Uluslararası", desc: "Avrupa ve Orta Doğu'da projelere imza attık." },
        { year: "2024", title: "Yeni Çağ", desc: "Yapay zeka destekli tasarım süreçlerine geçtik." },
      ],
    },
    portfolio: {
      tag: "Çalışmalarımız",
      title: "Seçili projeler",
      subtitle: "Markalara değer katan, ödüllü işlerimizden bir seçki.",
      cta: "Tüm projeleri gör",
      view: "Vaka çalışmasını incele",
      items: [
        { title: "Nova Finance", category: "Web & Ürün Tasarımı", desc: "Fintech platformu için uçtan uca dijital deneyim." },
        { title: "Aura Cosmetics", category: "Marka & E-Ticaret", desc: "Lüks kozmetik markası için e-ticaret deneyimi." },
        { title: "Pulse Analytics", category: "SaaS Arayüz", desc: "Veri analitiği panosu ve tasarım sistemi." },
        { title: "Orbit Travel", category: "Mobil Uygulama", desc: "Seyahat severler için akıllı rezervasyon uygulaması." },
        { title: "Vertex Studio", category: "Marka Kimliği", desc: "Mimari stüdyo için modern marka kimliği." },
        { title: "Lumen Energy", category: "Web Tasarım", desc: "Yenilenebilir enerji şirketi için kurumsal site." },
      ],
    },
    testimonials: {
      tag: "Referanslar",
      title: "Müşterilerimiz ne diyor?",
      subtitle: "Birlikte çalıştığımız markaların deneyimleri.",
      items: [
        { name: "Lukas Brandt", role: "Kurucu, Brightwave", quote: "Ekibin çalışma disiplini ve şeffaflığı bizi çok etkiledi. Net bir vizyonla ilerlediler ve marka görünürlüğümüz birkaç ay içinde katlandı." },
        { name: "Camille Roux", role: "Pazarlama Direktörü, Maison Vert", quote: "Tecrübeleri her aşamada hissediliyordu. Stratejik yaklaşımları sayesinde sosyal medyadaki erişimimiz üç katına çıktı." },
        { name: "Deren Akhanlı", role: "Genel Müdür, Vektör Dijital", quote: "Yalnızca reklam vermiyorlar; markanın vizyonunu anlayıp uzun vadeli bir büyüme planı kuruyorlar. Görünürlüğümüz ciddi şekilde arttı." },
        { name: "Tunç Söğütlü", role: "Kurucu Ortak, Pulse Yapı", quote: "Çalışma şekilleri titiz ve veri odaklı. Deneyimli ekipleri sayesinde dönüşüm oranlarımız ve marka bilinirliğimiz katlandı." },
      ],
    },
    contact: {
      tag: "İletişim",
      title: "Bir sonraki büyük projeye başlayalım",
      subtitle: "Fikrinizi anlatın, 24 saat içinde size özel bir teklifle dönelim.",
      note: "İster yeni bir girişim ister köklü bir marka olun, her projeye aynı özen ve titizlikle yaklaşıyoruz. Önce hedeflerinizi dinliyor, ardından size özel bir yol haritası ve şeffaf bir teklif hazırlıyoruz. Tanışma görüşmemiz tamamen ücretsiz — kahve bizden.",
      fields: { name: "Ad Soyad", email: "E-posta", company: "Şirket", message: "Projenizden bahsedin" },
      industryLabel: "Sektör",
      industries: ["E-Ticaret", "Hizmet", "Teknoloji", "Sağlık", "Gayrimenkul", "Diğer"],
      budgetLabel: "Bütçe Aralığı (USD)",
      budgets: ["< $1.000", "$1.000 - $5.000", "$5.000 - $10.000", "$10.000+"],
      button: "Teklif Al",
      sending: "Gönderiliyor...",
      success: "Mesajınız alındı! En kısa sürede size döneceğiz.",
      info: {
        emailLabel: "E-posta", email: "info@lukidigital.com",
        phoneLabel: "İngiltere", phone: "+44 737 8918 049",
        addressLabel: "İngiltere Ofisi", address: "Covent Garden, London, United Kingdom",
        phoneTrLabel: "Türkiye", phoneTr: "+90 553 868 05 88",
        addressTrLabel: "Türkiye Ofisi", addressTr: "Şişli, İstanbul, Türkiye",
      },
    },
    footer: {
      tagline: "Dijital dünyada iz bırakan markalar oluşturuyoruz.",
      navTitle: "Menü",
      servicesTitle: "Hizmetler",
      contactTitle: "İletişim",
      rights: "Tüm hakları saklıdır.",
      newsletter: "Güncel kalın",
      newsletterDesc: "Yeni projeler ve içgörüler için bültenimize katılın.",
      subscribe: "Abone Ol",
      emailPlaceholder: "E-posta adresiniz",
    },
  },

  en: {
    nav: {
      about: "About Us",
      services: "Services",
      portfolio: "Portfolio",
      blog: "Blog",
      contact: "Contact",
      advertising: "The Importance of Marketing",
      cta: "Get a Quote",
    },
    hero: {
      badge: "Premium Digital Agency",
      titlePre: "Building Brands That ",
      titleHighlight: "Leave a Mark",
      titlePost: " in the Digital World",
      desc: "Premium digital solutions, branding, web design, software development and growth strategies that carry your brand into the future.",
      primary: "Get a Quote",
      secondary: "View Our Work",
      awardTitle: "Awwwards",
      awardSub: "Site of the Day",
      statValue: "+180%",
      statSub: "Avg. Conversion",
      stats: [
        { value: "150+", label: "Projects Delivered" },
        { value: "90+", label: "Happy Clients" },
        { value: "98%", label: "Success Rate" },
      ],
    },
    marquee: {
      label: "Our areas of expertise",
      words: ["Google ADS", "Web Design", "Social Media", "Meta ADS", "E-Commerce", "Marketing", "Strategy", "TikTok ADS"],
    },
    quotes: {
      tag: "Inspiration",
      title: "The Importance of Advertising",
      subtitle: "Words that best capture the power of advertising.",
      items: [
        { author: "Henry Ford", text: "If you wouldn't stop doing business, don't stop advertising." },
        { author: "Howard Gossage", text: "People don't read ads. People read what interests them. Sometimes it's an ad." },
        { author: "Mark Twain", text: "The right kind of advertising can make a small business look big, and a big business look bigger." },
        { author: "Henry Ford", text: "A man who stops advertising to save money is like a man who stops a clock to save time." },
      ],
    },
    services: {
      tag: "Our Services",
      title: "Advertising solutions that grow your brand",
      subtitle: "We make a difference in digital with data-driven campaigns and creative content.",
      cta: "Get Started",
      items: [
        {
          slug: "google-ads",
          title: "Google ADS",
          sub: "Top of Search",
          desc: "With the right keywords and data-driven campaigns, we put you in front of customers exactly when they're searching.",
          features: ["Search & Display Network", "Remarketing", "Conversion Tracking"],
          metrics: [{ label: "Return on Ad Spend (ROAS)", value: "4.2x" }, { label: "Conversion Rate", value: "+65%" }],
        },
        {
          slug: "meta-ads",
          title: "Meta ADS",
          sub: "Visibility on Social",
          desc: "We build conversion-focused ad funnels tailored to your audience on Facebook and Instagram.",
          features: ["Facebook & Instagram", "Audience Analysis", "Creative Ads"],
          metrics: [{ label: "Total Reach", value: "3.5M" }, { label: "Cost per Click (CPC)", value: "-40%" }],
        },
        {
          slug: "tiktok-ads",
          title: "TikTok ADS",
          sub: "Viral Growth",
          desc: "We connect your brand with next-gen audiences through creative content that rides the trends.",
          features: ["Trend Content", "Influencer Collabs", "Video Production"],
          metrics: [{ label: "Views", value: "12M+" }, { label: "Engagement Rate", value: "+120%" }],
        },
        {
          slug: "social-media",
          title: "Social Media Management",
          sub: "Your Brand Voice",
          desc: "From content creation to community management, we run your social accounts end to end.",
          features: ["Content Calendar", "Community Management", "Monthly Reporting"],
          metrics: [{ label: "Follower Growth", value: "+85%" }, { label: "Engagement", value: "+140%" }],
        },
      ],
    },
    about: {
      tag: "About Us",
      title: "A team where creativity meets technology",
      subtitle:
        "LUKI is a digital agency that combines strategy, design and technology to help brands make a difference in the digital world.",
      paragraphs: [
        "As clever, agile and curious as our fox. We approach every project with measurable goals and bold ideas.",
        "We see design as a feeling and technology as a tool — combining both to create lasting digital experiences.",
      ],
      mission: {
        title: "Our Mission",
        desc: "To grow brands with memorable, measurable and sustainable digital experiences.",
      },
      vision: {
        title: "Our Vision",
        desc: "To be a reference agency in design and technology, reaching from Türkiye to the world.",
      },
      stats: [
        { value: "98%", label: "Client Retention" },
        { value: "3 hours", label: "Avg. Response" },
      ],
      timelineTitle: "Our Journey",
      timeline: [
        { year: "2013", title: "Founded", desc: "LUKI started out as a small design studio." },
        { year: "2017", title: "Growth", desc: "We grew our team and added software services." },
        { year: "2021", title: "International", desc: "We delivered projects across Europe and the Middle East." },
        { year: "2024", title: "New Era", desc: "We moved to AI-assisted design processes." },
      ],
    },
    portfolio: {
      tag: "Our Work",
      title: "Selected projects",
      subtitle: "A selection of our award-winning work that adds value to brands.",
      cta: "View all projects",
      view: "View case study",
      items: [
        { title: "Nova Finance", category: "Web & Product Design", desc: "End-to-end digital experience for a fintech platform." },
        { title: "Aura Cosmetics", category: "Branding & E-Commerce", desc: "E-commerce experience for a luxury cosmetics brand." },
        { title: "Pulse Analytics", category: "SaaS Interface", desc: "Data analytics dashboard and design system." },
        { title: "Orbit Travel", category: "Mobile App", desc: "Smart booking app for travel lovers." },
        { title: "Vertex Studio", category: "Brand Identity", desc: "Modern brand identity for an architecture studio." },
        { title: "Lumen Energy", category: "Web Design", desc: "Corporate site for a renewable energy company." },
      ],
    },
    testimonials: {
      tag: "Testimonials",
      title: "What our clients say",
      subtitle: "Experiences from the brands we work with.",
      items: [
        { name: "Lukas Brandt", role: "Founder, Brightwave", quote: "The team's discipline and transparency truly impressed us. They moved with a clear vision and our brand visibility multiplied within a few months." },
        { name: "Camille Roux", role: "Marketing Director, Maison Vert", quote: "Their experience showed at every stage. Thanks to their strategic approach, our social media reach tripled." },
        { name: "Deren Akhanlı", role: "General Manager, Vektör Dijital", quote: "They don't just run ads; they understand the brand's vision and build a long-term growth plan. Our visibility increased significantly." },
        { name: "Tunç Söğütlü", role: "Co-Founder, Pulse Yapı", quote: "Their way of working is meticulous and data-driven. Thanks to their experienced team, our conversion rates and brand awareness multiplied." },
      ],
    },
    contact: {
      tag: "Contact",
      title: "Let's start your next big project",
      subtitle: "Tell us about your idea and we'll get back with a tailored quote within 24 hours.",
      note: "Whether you're an early-stage startup or an established brand, we treat every project with the same care and attention. First we listen to your goals, then we craft a tailored roadmap and a transparent quote. Our intro call is completely free — the coffee's on us.",
      fields: { name: "Full Name", email: "Email", company: "Company", message: "Tell us about your project" },
      industryLabel: "Industry",
      industries: ["E-Commerce", "Services", "Technology", "Health", "Real Estate", "Other"],
      budgetLabel: "Budget Range (USD)",
      budgets: ["< $1,000", "$1,000 - $5,000", "$5,000 - $10,000", "$10,000+"],
      button: "Get a Quote",
      sending: "Sending...",
      success: "Your message has been received! We'll get back to you shortly.",
      info: {
        emailLabel: "Email", email: "info@lukidigital.com",
        phoneLabel: "United Kingdom", phone: "+44 737 8918 049",
        addressLabel: "UK Office", address: "Covent Garden, London, United Kingdom",
        phoneTrLabel: "Türkiye", phoneTr: "+90 553 868 05 88",
        addressTrLabel: "TR Office", addressTr: "Şişli, İstanbul, Türkiye",
      },
    },
    footer: {
      tagline: "Building brands that leave a mark in the digital world.",
      navTitle: "Menu",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rights: "All rights reserved.",
      newsletter: "Stay in the loop",
      newsletterDesc: "Join our newsletter for new projects and insights.",
      subscribe: "Subscribe",
      emailPlaceholder: "Your email address",
    },
  },
};
